var _g, _path, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncSettingBanner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 228,
  height: 145,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-setting-banner_svg__a)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 98,
  height: 40.519,
  x: 29,
  y: 28.711,
  fill: "#008060",
  rx: 9.423
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  d: "M119.473 24H36.527a2.816 2.816 0 0 0-2.816 2.816v34.888a2.815 2.815 0 0 0 2.816 2.815h82.946a2.815 2.815 0 0 0 2.815-2.815V26.816A2.815 2.815 0 0 0 119.473 24"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C9196",
  d: "M51.895 33.423h1.325v1.369h-1.325zM51.895 52.019h1.325v2.65h9.276V34.792H53.22v2.65h-1.325v-2.65h-9.276v19.877h9.276zm7.837-1.051-.937.937-.937-.937-.937.937-.937-.937.937-.937-.937-.937.937-.937.937.937.937-.937.937.937-.937.937zM56.339 38.96l.857.857 2.181-2.182.937.937-3.118 3.119-1.794-1.794zm0 5.301.857.857 2.181-2.182.937.937-3.118 3.118-1.794-1.793zm-4.444-5.495h1.325v2.65h-1.325zm0 3.976h1.325v3.975h-1.325zm0 5.3h1.325v2.65h-1.325zm-2.764 2.925-.937.937-.937-.937-.937.937-.937-.937.937-.937-.937-.937.937-.937.937.937.937-.937.937.937-.937.937zm0-5.3-.937.936-.937-.937-.937.937-.937-.937.937-.937-.937-.936.937-.937.937.937.937-.937.937.937-.937.936zm-2.537-3.976-1.793-1.794.937-.937.856.857 2.182-2.182.937.937zM51.895 54.669h1.325v1.369h-1.325z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  fillRule: "evenodd",
  d: "M71.788 37.588c0-.739.598-1.337 1.337-1.337h36.26a1.336 1.336 0 0 1 0 2.674h-36.26a1.337 1.337 0 0 1-1.337-1.337m0 6.443c0-.739.598-1.337 1.337-1.337h27.681a1.337 1.337 0 0 1 0 2.674H73.125a1.337 1.337 0 0 1-1.337-1.337m1.337 5.106a1.337 1.337 0 0 0 0 2.674h32.086a1.336 1.336 0 0 0 0-2.674z",
  clipRule: "evenodd"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-setting-banner_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 144,
  height: 95,
  x: 69,
  y: 36,
  fill: "#DCDCDC",
  rx: 4
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-setting-banner_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 144,
  height: 92,
  x: 67,
  y: 36,
  fill: "#fff",
  rx: 4
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  fillRule: "evenodd",
  d: "M199.385 133.868c1.846 0 1.846-2.868 0-2.868s-1.847 2.868 0 2.868m0 7.888c1.846 0 1.846-2.869 0-2.869s-1.847 2.869 0 2.869m6.752 0c1.82 0 1.82-2.868 0-2.868-1.873 0-1.873 2.868 0 2.868m6.732 0c1.833 0 1.833-2.868 0-2.868s-1.885 2.868 0 2.868m6.73 0c1.847 0 1.847-2.868 0-2.868s-1.846 2.868 0 2.868m6.717 0c1.846 0 1.846-2.868 0-2.868s-1.846 2.868 0 2.868m-20.179-7.888c1.82 0 1.82-2.868 0-2.868-1.873 0-1.873 2.868 0 2.868m6.732 0c1.833 0 1.833-2.868 0-2.868s-1.885 2.868 0 2.868m6.73 0c1.847 0 1.847-2.868 0-2.868s-1.846 2.868 0 2.868m6.717 0c1.846 0 1.846-2.868 0-2.868s-1.846 2.868 0 2.868",
  clipRule: "evenodd",
  opacity: 0.37
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M173.828 78.858c0-9.761-7.54-17.702-16.808-17.702-1.462 0-2.908.196-4.297.582l-2.993.833-1.328-2.945C146.04 54.386 140.967 51 135.479 51c-7.883 0-14.295 6.754-14.295 15.056v5.274h-5.144c-10.393 0-18.98 8.774-19.04 19.72-.06 10.989 8.412 19.95 18.832 19.95h55.403c7.602 0 13.765-6.491 13.765-14.498 0-6.996-4.962-12.769-11.381-13.635l.175-2.905c.022-.368.034-.74.034-1.104"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M179.763 53.106h-19.631A9.13 9.13 0 0 0 151 62.237v19.632A9.13 9.13 0 0 0 160.132 91h19.631a9.13 9.13 0 0 0 9.132-9.131V62.237a9.13 9.13 0 0 0-9.132-9.132"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  d: "M179.763 51h-19.631A9.13 9.13 0 0 0 151 60.132v19.631a9.13 9.13 0 0 0 9.132 9.132h19.631a9.13 9.13 0 0 0 9.132-9.132V60.132A9.13 9.13 0 0 0 179.763 51"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M169.796 61.454c2.109 0 4.108.69 5.759 1.944l-3.822 3.599 9.722 1.042-.457-9.767-3.876 3.65a11.58 11.58 0 0 0-7.326-2.59c-6.433 0-11.667 5.235-11.667 11.668h2.121c0-5.264 4.282-9.546 9.546-9.546M169.795 80.546a9.48 9.48 0 0 1-5.759-1.945l3.823-3.598-9.723-1.043.457 9.767 3.877-3.65a11.58 11.58 0 0 0 7.325 2.59c6.433 0 11.667-5.234 11.667-11.667h-2.121c0 5.264-4.282 9.546-9.546 9.546"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M169.796 59.636c2.109 0 4.108.69 5.759 1.944l-3.822 3.599 9.722 1.042-.457-9.767-3.876 3.65a11.58 11.58 0 0 0-7.326-2.59c-6.433 0-11.667 5.235-11.667 11.667h2.121c0-5.263 4.282-9.545 9.546-9.545M169.795 78.727a9.48 9.48 0 0 1-5.759-1.944l3.823-3.599-9.723-1.042.457 9.767 3.877-3.65a11.58 11.58 0 0 0 7.325 2.59c6.433 0 11.667-5.235 11.667-11.667h-2.121c0 5.263-4.282 9.545-9.546 9.545"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M90.3 75H58.7C50.58 75 44 81.581 44 89.7V121.3C44 129.419 50.581 136 58.7 136h31.6c8.119 0 14.7-6.581 14.7-14.699V89.699C105 81.581 98.419 75 90.3 75"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  d: "M91.451 72H59.55c-8.195 0-14.839 6.644-14.839 14.839v31.901c0 8.195 6.644 14.839 14.839 14.839H91.45c8.195 0 14.839-6.644 14.839-14.839V86.839C106.29 78.644 99.646 72 91.451 72"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "m93.382 97.16-3.363-.426a17 17 0 0 0-1.017-2.458l2.076-2.674c.84-1.082.742-2.61-.218-3.54l-2.817-2.816c-.94-.97-2.467-1.066-3.55-.227l-2.67 2.076a17 17 0 0 0-2.46-1.018l-.428-3.357a2.68 2.68 0 0 0-2.657-2.36H72.27a2.68 2.68 0 0 0-2.658 2.355l-.427 3.362c-.855.277-1.678.617-2.46 1.018l-2.672-2.076c-1.08-.84-2.608-.743-3.54.218l-2.816 2.815c-.97.94-1.068 2.468-.227 3.552l2.076 2.672c-.4.781-.74 1.604-1.018 2.458l-3.357.427a2.68 2.68 0 0 0-2.36 2.657v4.007a2.677 2.677 0 0 0 2.355 2.657l3.362.428c.277.853.62 1.676 1.018 2.457l-2.076 2.674c-.841 1.082-.743 2.61.218 3.54l2.817 2.817c.94.967 2.466 1.064 3.55.225l2.672-2.077c.782.401 1.605.743 2.458 1.018l.427 3.355a2.68 2.68 0 0 0 2.658 2.365h4.007a2.68 2.68 0 0 0 2.657-2.356l.428-3.362a17 17 0 0 0 2.457-1.018l2.674 2.077c1.082.84 2.61.742 3.54-.218l2.817-2.817c.97-.941 1.068-2.467.227-3.55l-2.076-2.673c.4-.781.742-1.604 1.017-2.457l3.356-.428a2.677 2.677 0 0 0 2.36-2.657v-4.007a2.676 2.676 0 0 0-2.353-2.657m-19.108 13.604c-4.93 0-8.943-4.011-8.943-8.942s4.012-8.943 8.943-8.943c4.932 0 8.943 4.012 8.943 8.943s-4.011 8.942-8.943 8.942"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m93.516 96.426-3.17-.403a16 16 0 0 0-.96-2.317l1.958-2.521c.793-1.02.7-2.46-.205-3.337l-2.657-2.656c-.885-.914-2.325-1.005-3.347-.214l-2.518 1.957a16 16 0 0 0-2.319-.96l-.403-3.164a2.526 2.526 0 0 0-2.505-2.226h-3.778a2.525 2.525 0 0 0-2.506 2.22l-.403 3.17c-.806.262-1.582.583-2.319.96l-2.52-1.957c-1.018-.791-2.458-.7-3.337.205l-2.656 2.654c-.914.888-1.006 2.328-.214 3.35l1.958 2.52a16 16 0 0 0-.96 2.316l-3.165.403a2.526 2.526 0 0 0-2.226 2.506v3.777c0 1.277.956 2.354 2.221 2.506l3.17.403q.394 1.21.96 2.317l-1.958 2.521c-.792 1.02-.7 2.461.206 3.337l2.656 2.657c.887.912 2.325 1.003 3.347.212l2.52-1.958c.737.378 1.512.7 2.317.96l.403 3.163a2.525 2.525 0 0 0 2.506 2.229h3.778a2.525 2.525 0 0 0 2.505-2.221l.403-3.17q1.21-.393 2.317-.959l2.522 1.957c1.02.793 2.46.7 3.337-.205l2.656-2.656c.914-.887 1.007-2.326.214-3.347l-1.957-2.52c.377-.737.7-1.512.959-2.317l3.164-.403a2.526 2.526 0 0 0 2.226-2.506v-3.777a2.523 2.523 0 0 0-2.22-2.506m-18.015 12.826c-4.65 0-8.432-3.782-8.432-8.431 0-4.65 3.782-8.432 8.432-8.432s8.432 3.782 8.432 8.432c0 4.649-3.783 8.431-8.432 8.431"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "sync-setting-banner_svg__a",
  width: 154.538,
  height: 97.058,
  x: 0.731,
  y: 0.442,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_13684_16613",
  stdDeviation: 14.135
})), /*#__PURE__*/React.createElement("filter", {
  id: "sync-setting-banner_svg__b",
  width: 144,
  height: 96,
  x: 69,
  y: 36,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13684_16613"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13684_16613",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "sync-setting-banner_svg__c",
  width: 144,
  height: 93,
  x: 67,
  y: 36,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13684_16613"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13684_16613",
  result: "shape"
})))));
export { SvgSyncSettingBanner as ReactComponent };
export default __webpack_public_path__ + "static/media/sync-setting-banner.1400cdec.svg";